var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-home"},[_c('klook-icon',{attrs:{"type":_vm.isZhCN ? 'logo-zh' : 'logo',"size":[_vm.isZhCN ? 264 : 216, 36]}}),_c('redeem-voucher',{staticClass:"redeem-voucher-module"}),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }